(function () {
	'use strict';

	angular
		.module('app.core')
		.service('excelExportService', excelExportService);

	excelExportService.$inject = ['$rootScope', '$uibModal', '$timeout', '$http', 'URLS'];

	function excelExportService($rootScope, $uibModal, $timeout, $http, URLS) {
		var stageTimeout, modalScope, modalInstance;
		var DEFAULT_TIMEOUT = 2000;
		var NETWORK_ERROR_TIMEOUT = 5000;

		return {
			getExcelReport: getExcelReport,
			getExcelReportNew: getExcelReportNew,
			getExcelReportWithGet: getExcelReportWithGet,
			getReportStatus: getReportStatus,
			downloadReport: downloadReport
		};

		function getExcelReport(modalScope, reportName, factories, params, errorScope) {
			var url = factories + '/ExcelReports/' + reportName;
			modalScope.loadingMessage = 'Exporting...';
			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/core/loading.html',
				windowClass: 'center-modal uib-modal-excel-z-above-all',
				backdropClass: 'uib-modal-excel-backdrop-z-above-all',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};
			var instance = $uibModal.open(opts);
			jQuery.fileDownload(URLS.host + URLS.prefix + url, {
				httpMethod: 'POST',
				data: params,
				encodeHTMLEntities: false,
				successCallback: function (url) {
					if (instance) {
						instance.close();
					}
				},
				failCallback: function (responseHtml, url) {
					if (instance) {
						instance.close();
					}
					errorScope.errorMessage = 'Could not download report, an error has occurred';
					$timeout(function () {
						errorScope.errorMessage = '';
					}, 5000);
				}
			});
		}

		function getExcelReportNew(reportName, factories, params, url, scope, useJson, isCsv, customFileName) {
			if (typeof url === 'undefined') {
				url = URLS.prefix + factories + '/ExcelReports/' + reportName;
			}
			var postObj = {
				method: 'POST',
				url: URLS.host + url
			};
			if (!useJson) {
				postObj.data = jQuery.param(params);
				postObj.headers = {
					'Content-Type': 'application/x-www-form-urlencoded'
				};
			} else {
				postObj.data = params;
			}
			return $http(postObj).then(getExcelComplete, getExcelError);

			function getExcelComplete(response) {
				getReportStatus(response.data.id, factories, undefined, isCsv, customFileName, 0);

				modalScope = scope;
				modalScope.state = 'Queued';
				modalScope.closeModal = function () {
					modalInstance.close();
				};
				var opts = {
					scope: modalScope,
					templateUrl: '/application/f/core/excel-export/excel-export-modal.html',
					windowClass: 'center-modal uib-modal-excel-z-above-all',
					backdropClass: 'uib-modal-excel-backdrop-z-above-all',
					animation: true,
					windowTemplateUrl: '/application/f/core/excel-export/export-template.html',
					backdrop: 'static'
				};
				modalInstance = $uibModal.open(opts);
			}

			function getExcelError(error) {
				if (error.status === 409) {
					$rootScope.$emit('toast', {
						'message': 'We are already processing this request.',
						'success': false
					});
				} else {
					$rootScope.$emit('toast', {
						'message': 'We could not process your request. Please try again later.',
						'success': false
					});
				}
			}
		}

		function getExcelReportWithGet(factories, url, scope, useLoggedInSite, isCsv, customFileName) {
			return $http.get(url).then(getExcelComplete, getExcelError);

			function getExcelComplete(response) {
				useLoggedInSite = (typeof useLoggedInSite !== 'undefined' && useLoggedInSite);
				getReportStatus(response.data.id, factories, useLoggedInSite, isCsv, customFileName, 0);

				modalScope = scope;
				modalScope.state = 'Queued';
				modalScope.closeModal = function () {
					modalInstance.close();
				};
				var opts = {
					scope: modalScope,
					templateUrl: '/application/f/core/excel-export/excel-export-modal.html',
					windowClass: 'center-modal uib-modal-excel-z-above-all',
					backdropClass: 'uib-modal-excel-backdrop-z-above-all',
					animation: true,
					windowTemplateUrl: '/application/f/core/excel-export/export-template.html',
					backdrop: 'static'
				};
				modalInstance = $uibModal.open(opts);
			}

			function getExcelError(error) {
				if (error.status === 409) {
					$rootScope.$emit('toast', {
						'message': 'We are already processing this request.',
						'success': false
					});
				} else {
					$rootScope.$emit('toast', {
						'message': 'We could not process your request. Please try again later.',
						'success': false
					});
				}
			}
		}

		function getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount) {
			return $http({
				method: 'GET',
				url: URLS.host + URLS.prefix + (useLoggedInSite ? globalConfig.factory.id : factories) +
						'/ExportRequest/' + id + '/State'
			}).then(getRequestStatusSuccess, getRequestStatusError);

			function getRequestStatusSuccess(response) {
				retryCount = 0;
				switch (response.data.state) {
				case 'QUEUED':
				case 'MARKED':
					modalScope.state = 'In Queue';
					stageTimeout = $timeout(function () {
						getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount);
					}, DEFAULT_TIMEOUT);
					break;
				case 'PROCESSING':
					modalScope.state = 'Preparing';
					stageTimeout = $timeout(function () {
						getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount);
					}, DEFAULT_TIMEOUT);
					break;
				case 'QUERYING':
					modalScope.state = 'Getting Data';
					stageTimeout = $timeout(function () {
						getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount);
					}, DEFAULT_TIMEOUT);
					break;
				case 'ERROR_QUERY_TIMEOUT':
				case 'ERROR_BUILD_TIMEOUT':
					$timeout.cancel(stageTimeout);
					modalInstance.close();
					$rootScope.$emit('toast', {
						'message': 'We could not process your request because the query took too long. Try filtering the query to have fewer rows.',
						'success': false,
						'time': 6000
					});
					break;
				case 'BUILDING':
					modalScope.state = 'Preparing Report';
					stageTimeout = $timeout(function () {
						getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount);
					}, DEFAULT_TIMEOUT);
					break;
				case 'UPLOADING':
					modalScope.state = 'Finishing up';
					stageTimeout = $timeout(function () {
						getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount);
					}, DEFAULT_TIMEOUT);
					break;
				case 'READY':
					modalScope.state = 'Downloading';
					$timeout.cancel(stageTimeout);
					$timeout(function () {
						modalInstance.close();
						// Saving for when the user is able to dismiss the modal
						// $rootScope.$emit('toast', {
						// 	'message': 'Excel report ready. Downloading now.',
						// 	'success': true,
						// 	'time': 5000
						// });
						downloadReport(id, factories, useLoggedInSite, isCsv, customFileName);
					}, 2000);
					break;
				case 'ERROR':
					$timeout.cancel(stageTimeout);
					modalInstance.close();
					$rootScope.$emit('toast', {
						'message': 'We could not process your request. Please try again later.',
						'success': false,
						'time': 6000
					});
					break;
				case 'REMOVED': 
				default:
					break;
				}
			}

			function getRequestStatusError(error) {
				var errorMessage = 'We could not process your request. Please try again later.';
				// Network error, no connectivity
				if (error.status === -1) {
					if (retryCount === 0) {
						errorMessage = 'Please check your network connectivity. Retrying in a few seconds.';
						$rootScope.$emit('toast', {
							'message': errorMessage,
							'success': false
						});
					}
					if (retryCount >= 12) { 
						errorMessage = 'A network error prevented the download of your report. Please make sure you are connected to the network, and try exporting this report again once you are connected.';
					} else {
						stageTimeout = $timeout(function () {
							getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount + 1);
						}, NETWORK_ERROR_TIMEOUT);
						return;
					}
				} else if (error.status === 502 || error.status === 503) {
					if (retryCount <= 30) {
						stageTimeout = $timeout(function () {
							getReportStatus(id, factories, useLoggedInSite, isCsv, customFileName, retryCount + 1);
						}, DEFAULT_TIMEOUT);
						return;
					}
				}
				$rootScope.$emit('toast', {
					'message': errorMessage,
					'success': false
				});
				
				$timeout.cancel(stageTimeout);
				modalInstance.close();
			}
		}

		function downloadReport(id, factories, useLoggedInSite, isCsv, customFileName, retryCount) {
			if (!retryCount) {
				retryCount = 0;
			}
			var url = URLS.host + URLS.prefix + (useLoggedInSite ? globalConfig.factory.id : factories) +
				'/ExportRequest/' + id;

			if (isCsv) {
				url += '?isCsv=true';
			}

			if (customFileName) {
				url += (isCsv ? '&': '?') + 'customFileName=' + encodeURIComponent(customFileName);
			}
			jQuery.fileDownload(url, {
				httpMethod: 'GET',
				encodeHTMLEntities: false,
				failCallback: function (responseHtml, url) {
					if (retryCount < 5) {
						downloadReport(id, factories, useLoggedInSite, isCsv, customFileName, retryCount + 1);
					} else {
						$timeout(function () {
							$rootScope.$emit('toast', {
								'message': 'We could not process your request. Please try again later.',
								'success': false
							});
						}, 0);
					}
				}
			});
		}
	}
})();
